import request from "../../Request";
import {rThen} from "../../requestThen";

export let CheckEmailActivation = async (cid, key) => {

    return request.get(`/api/User/activation/email/check/${cid}/${key}`, false).then(r => {
        return rThen(r)
    })
}